import { render, staticRenderFns } from "./HostingPeriod.vue?vue&type=template&id=be09f9e2&scoped=true&"
import script from "./HostingPeriod.vue?vue&type=script&lang=js&"
export * from "./HostingPeriod.vue?vue&type=script&lang=js&"
import style0 from "./HostingPeriod.vue?vue&type=style&index=0&id=be09f9e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be09f9e2",
  null
  
)

export default component.exports